import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { List } from 'nallian-shared-ui/lib/components';
import OrganisationAddressService from '../services/organisationAddressService';
import OrganisationAddresses from './OrganisationAddress';

const ListContent = styled(List.Content)`
  display: flex;
  margin-bottom: 0.6rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: 0px solid transparent;
  }

  && .header {
    width: 12rem;
  }
`;

const OrganisationInfo = ({
  organisationId,
  dispatchOrganisationAddressGet,
  organisationAddressFetch,
  communityMemberFetch,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (organisationId) dispatchOrganisationAddressGet(organisationId);
  }, [t, dispatchOrganisationAddressGet, organisationId]);

  return (
    <>
      {organisationAddressFetch.pending ? (
        <div />
      ) : (
        <List relaxed divided>
          <List.Item>
            <ListContent>
              <List.Header>{t('organisationName')}:</List.Header>
              <List.Description>{communityMemberFetch.value?.organisation?.name}</List.Description>
            </ListContent>
            <ListContent>
              <List.Header>{t('address')}:</List.Header>
              <List.Description>
                <OrganisationAddresses addresses={organisationAddressFetch.value} />
              </List.Description>
            </ListContent>
          </List.Item>
        </List>
      )}
    </>
  );
};

OrganisationInfo.propTypes = {
  communityMemberFetch: PropTypes.object.isRequired,
  organisationId: PropTypes.string.isRequired,
  dispatchOrganisationAddressGet: PropTypes.func.isRequired,
  organisationAddressFetch: PropTypes.object.isRequired,
};

export default OrganisationAddressService(OrganisationInfo);
